import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: ${({ $isVisibility }) => $isVisibility ? '' : 'none'};
  width: 100%;
  height: 100%;
  overflow-y:auto;
  overflow-x:hidden;
  padding: 0.5rem;

  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`;

export const List = styled.ul`
  list-style-type: none;
  padding: .2rem;
  ${({ $reorderActive }) => $reorderActive && css`
    background: #d8f6f2;
    border-radius: 5px;
  `};

`
export const Item = styled.li`
  list-style-type: none;
  position: relative;
  > .banner {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    cursor: grab;
  } 

`

export const Reorder = styled.div`
  display: ${({ $isVisibility }) => $isVisibility ? 'flex' : 'none'};
  list-style-type: none;
  justify-content: end;
  padding: .3rem;

  > button {
    border: none;
    outline: none;
    display: flex;
    padding: 0 .5rem;
    color: rgb(153, 153, 153);
    cursor: pointer;
    background: transparent;
    justify-content: space-between;
    margin-bottom: 1rem;
    align-items: center;
    &:hover {
      filter: brightness(0.8);
    }
  }
  > .salveReorder{
    color: #0eaa96;
  }
  > .cancelReorder{
    color: #cf1214;
  }
`